import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, dark = false, align = "left" }) => (
  <div className={`mb-12 ${align === "center" ? "text-center" : ""}`}>
    <Reveal>
      <p className="font-mono text-xs tracking-[0.3em] text-emergency uppercase mb-4" data-testid={`eyebrow-${eyebrow?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight leading-[1.05] ${
          dark ? "text-white" : "text-zinc-900"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-4 text-base max-w-2xl ${align === "center" ? "mx-auto" : ""} ${dark ? "text-zinc-400" : "text-zinc-600"}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
